import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { Customer } from '../../shared/models/customer.interface';
import { Quote } from '../../shared/models/quote.interface';
import { LeadService } from '../services/lead.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';

@Component({
  selector: 'app-convert',
  templateUrl: './convert.component.html',
  styleUrls: ['./convert.component.scss']
})
export class ConvertComponent extends AbstractBiditComponent implements OnInit {
  lead: Quote = {
    customer: {} as Customer
  } as Quote;

  constructor(private leadService: LeadService, deviceDetectorService: DeviceDetectorService, private router: Router, private route: ActivatedRoute) {
    super(deviceDetectorService);
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      let id = params.get('quoteId');

      if (id) {
        this.refreshLead(parseInt(id));
      }
    });
  }

  refreshLead(quoteId: number) {
    this.leadService.getProject(quoteId)
      .subscribe({
        next: (data) => {
          data.quote.quote_IsLead = false;

          this.lead = data.quote;
        },
        error: (error: string) => this.errors = error
      });
  }

  createQuote() {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    this.leadService.createQuote(this.lead.quote_ID)
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe(
        {
          next: (result) => {
            if (result) {
              this.router.navigate(['/quote/' + result]);
            }
          },
          error: (error: string) => this.errors = error
        });
  }
}
